module.exports = __webpack_public_path__ + "media/images/filter-slash-3fbb2b5e.svg";